<template>
  <div>
    <TableToolTemp class="tab-tool-sub" :toolListProps="DataProps" @handleTool="handleTool"></TableToolTemp>
    <div class="integralWrapper">
      <el-radio-group v-model="initParam.param.recordType" @change="handleChange">
        <el-radio-button v-for="(item, index) in buttonStatus" :key="item.code + index" :label="item.code">{{
          item.label
        }}</el-radio-button>
      </el-radio-group>
      <p class="detailData">
        <span> 可用积分：{{ infoData.currentPoints }} </span>
        <span> 累计充值：{{ infoData.totalRechargePoints }}</span>
        <span> 累计分配：{{ infoData.totalAllocatePoints }}</span>
        <span> 累计回收：{{ infoData.totalRetrievePoints }}</span>
      </p>
    </div>
    <Table :data="listData" :options="listDataOptions" :align="'center'"> </Table>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
    ></Pagination>
    <!-- 分配 -->
    <DtPopup :isShow.sync="allocationPopupShow" @close="allocationPopupShow = false" title="分配" :footer="false">
      <p>最大可分配数量：{{ infoData.currentPoints }}</p>
      <p class="allocationTip"><i class=""></i> 仅允许向该企业下员工/HR分配积分，分配后有效期为一年</p>
      <div class="allocationWrapper">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="单个分配" name="single">
            <el-form
              ref="singleForm"
              :rules="singlerules"
              :model="singleruleForm"
              label-position="left"
              label-width="120px"
            >
              <el-form-item label="证件类型" prop="distributeCardType">
                <el-select
                  clearable
                  v-model="singleruleForm.distributeCardType"
                  placeholder="证件类型"
                  style="max-width: 200px"
                >
                  <el-option
                    :label="item.dicItemName"
                    :value="item.dicItemCode"
                    v-for="(item, index) in this.cardTypeDic"
                    :key="index + 'dicList1'"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码" prop="distributeCardNo">
                <el-input v-model="singleruleForm.distributeCardNo" style="max-width: 200px"></el-input>
              </el-form-item>
              <el-form-item label="分配积分" prop="distributePoints">
                <el-input
                  v-model="singleruleForm.distributePoints"
                  style="max-width: 200px"
                  type="number"
                  step="100"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="distributeRemarks">
                <el-input
                  type="textarea"
                  v-model="singleruleForm.distributeRemarks"
                  style="max-width: 200px"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="btngroup">
              <el-button type="primary" @click="distributesinglesubmit">确定</el-button>
              <el-button type="primary" plain>取消</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="批量分配" name="multiple">
            <el-form ref="multipleruleForm" label-position="left" label-width="120px">
              <el-form-item>
                <span class="downTemplate" :style="{ color: themeObj.color, cursor: 'pointer' }" @click="downTemplate"
                  >下载导入模版</span
                >
              </el-form-item>
              <el-form-item label="导入数据">
                <el-upload
                  class="upload-demo"
                  ref="uploadMultiple"
                  action
                  :on-remove="multiplehandleRemove"
                  :on-success="multiplehandlesuccess"
                  :before-upload="multiplehandleBeforeupload"
                  :http-request="multiplehandleUploadForm"
                  :file-list="multipleimportdata"
                  :auto-upload="false"
                  :limit="2"
                  :on-change="multipleuploadChange"
                  accept=".xlsx,.xls"
                >
                  <el-button slot="trigger" size="small" type="primary">选择导入文件</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div class="btngroup">
              <el-button type="primary" @click="distributemultiplesubmit">确定</el-button>
              <el-button type="primary" plain>取消</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </DtPopup>
    <!-- 分配明细 -->
    <DtPopup
      :isShow.sync="detailPopupShow"
      @close="handleDistrbutionClose"
      title="分配明细"
      width="1200px"
      height="500px"
      :footer="false"
    >
      <distributionDetails v-if="detailPopupShow" ref="distributionDetails" />
    </DtPopup>
    <!-- 回收明细 -->
    <DtPopup
      :isShow.sync="retrievePopupShow"
      @close="handleRetrieveClose"
      title="回收明细"
      width="1200px"
      height="500px"
      :footer="false"
    >
      <retrieveDetails v-if="retrievePopupShow" ref="retrieveDetails" />
    </DtPopup>
  </div>
</template>
<script>
import TableToolTemp from '@/components/layouts/TableToolTemp';
import { myMixin } from '@/mixins';
import Pagination from '@/components/layouts/Pagination';
import Table from '@/components/layouts/table';
import DtPopup from '@/components/layouts/DtPopup';
import distributionDetails from './components/distributionDetails.vue';
import retrieveDetails from './components/retrieveDetails.vue';
import {
  enterprisePointRecordpage,
  enterprisePointInfo,
  platformDownload,
  enterprisePointDistributeSingle,
  distributeDownloadTemplate,
  enterprisePointDistributeMultiple,
} from '@/api/integralManage';
import { queryDic, getBscAndBbcUserNameDicItems } from '@/api/BSC';
import { getDicList } from '@/config/tool.js';
export default {
  components: {
    TableToolTemp,
    Pagination,
    Table,
    DtPopup,
    distributionDetails,
    retrieveDetails,
  },
  mixins: [myMixin],
  computed: {
    themeObj() {
      return this.$store.getters['layoutStore/getThemeObj'];
    },
  },
  data() {
    return {
      dicArr: ['allUserDics'],
      DataProps: {
        toolTitle: '积分管理',
        toolList: [
          { name: '分配', btnCode: '' },
          { name: '分配明细', btnCode: '' },
          { name: '回收明细', btnCode: '' },
        ],
      },
      buttonStatus: [
        {
          label: '全部',
          code: '',
        },
        {
          label: '分配',
          code: '2',
        },
        {
          label: '回收',
          code: '3',
        },
      ],
      infoData: {
        currentPoints: 0,
        totalRechargePoints: 0,
        totalAllocatePoints: 0,
        totalRetrievePoints: 0,
      },
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          recordType: '',
          enterpriseId: '',
        },
      },
      total: 0,
      listData: [],
      listDataOptions: [
        { prop: 'recordId', label: '批次号', width: 120 },
        { prop: 'createTime', label: '日期' },
        { prop: 'recordType', label: '类型' },
        { prop: 'recordPoints', label: '收入/支出' },
        { prop: 'recordBalance', label: '变动后积分' },
        { prop: 'createId', label: '操作人', dic: 'allUserDics' },
        { prop: 'recordRemarks', label: '备注' },
      ],
      fulllistDataOptions: [
        { prop: 'recordId', label: '批次号' },
        { prop: 'createTime', label: '日期' },
        { prop: 'recordType', label: '类型' },
        { prop: 'recordPoints', label: '收入/支出' },
        { prop: 'recordBalance', label: '变动后积分' },
        { prop: 'createId', label: '操作人', dic: 'allUserDics' },
        { prop: 'recordRemarks', label: '备注' },
      ],
      allocationPopupShow: false,
      activeName: 'single',
      singleruleForm: {
        enterpriseId: '',
        distributeCardType: '',
        distributeCardNo: '',
        distributePoints: null,
        distributeRemarks: '',
      },
      singlerules: {
        distributeCardType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        distributeCardNo: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
        distributePoints: [{ required: true, message: '请输入分配积分', trigger: 'blur' }],
        distributeRemarks: [{ required: true, message: '请填写备注', trigger: 'blur' }],
      },
      cardTypeDic: [],
      multipleimportdata: [],
      detailPopupShow: false,
      retrievePopupShow: false,
    };
  },
  methods: {
    handleTool(obj) {
      if (obj.name === '分配') {
        this.allocationPopupShow = true;
      } else if (obj.name === '分配明细') {
        this.detailPopupShow = true;
      } else if (obj.name === '回收明细') {
        this.retrievePopupShow = true;
      }
    },
    init() {
      this.queryData();
      this.queryInfo();
      this.getDics();
    },
    async queryData(bool = true) {
      // 默认将当前页数归1
      if (bool) this.initParam.pageNum = 1;
      this.initParam.param.enterpriseId = this.$store.state.user.user.enterpriseId;
      let res = await enterprisePointRecordpage(this.initParam);
      this.listData = res.list
        ? res.list.filter(item => {
            item.recordType == '2'
              ? (item.recordPoints = '-' + item.recordPoints)
              : (item.recordPoints = '+' + item.recordPoints);
            if (item.recordType == '1') {
              item.recordType = '充值';
            } else if (item.recordType == '2') {
              item.recordType = '分配';
            } else if (item.recordType == '3') {
              item.recordType = '回收';
            }
            return item;
          })
        : [];
      this.total = res.total;
    },
    async queryInfo() {
      let res = await enterprisePointInfo({ enterpriseId: this.$store.state.user.user.enterpriseId });
      if (res) {
        this.infoData.currentPoints = res.currentPoints ? res.currentPoints : 0;
        this.infoData.totalRechargePoints = res.totalRechargePoints ? res.totalRechargePoints : 0;
        this.infoData.totalAllocatePoints = res.totalAllocatePoints ? res.totalAllocatePoints : 0;
        this.infoData.totalRetrievePoints = res.totalRetrievePoints ? res.totalRetrievePoints : 0;
      }
    },
    handleChange(value) {
      if (value) {
        this.listDataOptions = this.listDataOptions.filter(item => {
          return item.prop != 'recordBalance';
        });
      } else {
        this.listDataOptions = _.cloneDeep(this.fulllistDataOptions);
      }
      this.queryData(true);
    },
    getAllUserDics() {
      getBscAndBbcUserNameDicItems({ operateType: '2' }).then(res => {
        this.$store.commit('mapDicData', { dicCode: 'allUserDics', dicItems: res });
      });
    },
    getDownloadFilePath(obj) {
      platformDownload({ isOnline: true, fileId: obj.recordVoucher, target: 0 }).then(data => {
        let alink = document.createElement('a');
        alink.href = URL.createObjectURL(data);
        alink.download = 'pingzheng.png'; //图片名
        alink.click();
      });
    },
    async getDics() {
      this.cardTypeDic = await getDicList('gen.identityType');
    },
    //分配
    async distributesinglesubmit() {
      this.$refs.singleForm.validate(async valid => {
        if (valid) {
          const r = /^\+?[1-9][0-9]*$/; //正整数
          if (
            !r.test(this.singleruleForm.distributePoints) ||
            this.singleruleForm.distributePoints < 100 ||
            this.singleruleForm.distributePoints % 100 != 0
          ) {
            this.$message.error('分配数量为正整数且为100的整数倍！');
            return;
          }
          this.singleruleForm.enterpriseId = this.$store.state.user.user.enterpriseId;
          let res = await enterprisePointDistributeSingle(this.singleruleForm);
          if (res) {
            this.$message.success('分配成功');
            this.distributehandlecancel();
            this.queryData(true);
            this.queryInfo();
          }
        }
      });
    },
    //批量分配
    distributemultiplesubmit() {
      if (this.muiltFile) {
        let fd = new FormData();
        fd.append('file', this.muiltFile);
        fd.append('enterpriseId', this.$store.state.user.user.enterpriseId);
        enterprisePointDistributeMultiple(fd).then(res => {
          if (res) {
            this.init();
            this.importShow = false;
            this.$message.success('导入成功');
            this.distributehandlecancel();
            this.queryData(true);
            this.queryInfo();
          }
        });
      } else {
        this.$message.warning('请选择上传文件');
      }
    },
    downTemplate() {
      distributeDownloadTemplate({ target: 1 });
    },
    multiplehandleRemove() {},
    multiplehandlesuccess() {},
    multiplehandleBeforeupload() {},
    multiplehandleUploadForm() {},
    multipleuploadChange(file, fileList) {
      this.muiltFile = file.raw;
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    distributehandlecancel() {
      this.$refs.uploadMultiple.clearFiles();
      this.singleruleForm.distributePoints = null;
      this.singleruleForm.distributeCardType = '';
      this.singleruleForm.distributeCardNo = '';
      this.singleruleForm.distributeRemarks = '';
      this.allocationPopupShow = false;
    },
    handleDistrbutionClose() {
      this.detailPopupShow = false;
      this.$refs.distributionDetails.clear();
    },
    handleRetrieveClose() {
      this.retrievePopupShow = false;
      this.$refs.retrieveDetails.clear();
    },
  },
  async created() {
    await this.getAllUserDics();
  },
};
</script>
<style lang="less" scoped>
.integralWrapper {
  display: flex;
  align-items: center;
  padding: 20px;
  .detailData {
    margin-left: 20px;
    span {
      margin-left: 20px;
      color: #909399;
    }
  }
}
.btngroup {
  text-align: center;
  margin: 20px;
}
.allocationTip {
  color: #909399;
  margin-top: 10px;
  i {
    // display: inline-block;
    // width: 16px;
    // height: 16px;
    // background: url(~@/assets/imgs/tip.png) center center;
    // background-size: 100% 100%;
    // vertical-align: middle;
  }
}
.allocationWrapper {
  padding: 20px;
}
</style>
